import Typography from "@mui/material/Typography";
import {Box, Stack, useTheme} from "@mui/material";
import {useContext} from "react";
import ReservationContext from "../context/ReservationContext";
import ErrorHandlingTextField, {validateNumber, validateRequired} from "../components/ErrorHandlingTextField";
import ErrorHandlingCheckbox from "../components/ErrorHandlingCheckbox";
import ErrorHandlingDatePicker, {
    validateRequiredAge,
    validateRequiredDate
} from "../components/ErrorHandlingDatePicker";
import {formatHuman} from "../utils/Utils";
import ErrorHandlingSelect from "../components/ErrorHandlingSelect";


const QuestionData = () => {
    const {questionData, setQuestionData, error, setError, questions} = useContext(ReservationContext)
    const theme = useTheme()
    const style = {color: theme.palette.primary[600]}
    const headingStyle = {color: theme.palette.primary[500]}

    const questionTypesMap = {
        '1': (props) => <ErrorHandlingTextField {...props} variant='standard'/>,
        '2': (props) => <ErrorHandlingTextField {...props} variant='standard'/>,
        '3': (props) => <Box><ErrorHandlingCheckbox {...props}/></Box>,
        '4': (props) => <ErrorHandlingDatePicker {...props}/>,
        '5': (props) => <ErrorHandlingSelect {...props} variant='standard'/>,
    }

    const createValidatorListForServiceQuestion = (q) => {
        const validatorList = []
        if (['1', '2'].includes(q?.answer_type) && q.required) validatorList.push(validateRequired);
        if (q?.answer_type === '2') validatorList.push(validateNumber);
        if (q?.answer_type === '4' && q.required) validatorList.push(validateRequiredDate, validateRequiredAge);
        return validatorList
    }

    const getData = (answer_type, obj) => {
        if (answer_type === '1') return obj.target.value
        if (answer_type === '2') return obj.target.value
        if (answer_type === '3') return obj.target.checked
        if (answer_type === '4') return formatHuman(obj)
        if (answer_type === '5') return obj.target.value
    }

    return <div className="data-container-fill">
        <Typography variant="headline6" gutterBottom style={style}>Extra kérdések</Typography>
        <form style={{marginTop: 10}}>
            <Stack spacing={1}>
                {questions?.map((q, i) => <Stack spacing={1} key={`question_${i}`}>
                    <Typography variant='caption' sx={headingStyle}>{q.question}{q.required && '*'}</Typography>
                    {questionTypesMap[q.answer_type]({
                        check: v => setError({...error, [`q_${q.id}`]: v}),
                        validators: createValidatorListForServiceQuestion(q),
                        name: `q_${q.id}`,
                        value: questionData[`q_${q.id}`] || '',
                        options: q?.options ? q?.options : [],
                        onValChange: e => setQuestionData({
                            ...questionData, [`q_${q.id}`]: getData(q.answer_type, e)
                        })
                    })}
                </Stack>)}
            </Stack>
        </form>
    </div>
}

export default QuestionData